/* eslint-disable no-shadow */
/* eslint-disable prefer-template */
import React, { useState } from 'react';
import PropTypes, { any } from 'prop-types';
import { useSelector } from 'react-redux';
import PlayersForCheckInItem from './PlayersForCheckInItem';
import ColumnHeader, { SortType } from '../../../components/ColumnHeader';

import styles from '../drawEdit.scss';

const PlayersForCheckIn = (props) => {
    const {
        players,
        showHighSchoolName,
        isLoading,
        handleSelectPlayerForCheckIn,
        handleSortByName,
     } = props;
    const [sortState, setSortState] = useState(SortType.ASC);

    const { drawsDict } = useSelector(({ drawEdit }) => {
        const { draws } = drawEdit;
        return {
            drawsDict: draws.drawsDict,
        };
    });
    return (
        <div className={`${styles.section} bg-transparent main-content`}>
            <div className={`check-in-container container mt32 bg-transparent`}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="all-players-header fs14 fw600 d-flex aic">
                            <div className="row flex-1">
                                <div className={`col-md-9`}>
                                    <div className="row">
                                        <div className={'col-md-3'}>
                                            <ColumnHeader
                                                isSortable
                                                columnName="Name"
                                                isSelected={true}
                                                sortType={sortState}
                                                initialSort={sortState}
                                                onClick={(srtType) => {
                                                    setSortState(srtType);
                                                    handleSortByName(srtType);
                                                }}
                                                data-testid="check-in.players.header-name"
                                            />
                                        </div>
                                        <div className="col-md-1">
                                            <ColumnHeader
                                                columnName="Age"
                                                data-testid="check-in.players.header-age"
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <ColumnHeader columnName="Phone Number" data-testid="check-in.players.header-phone" />
                                        </div>
                                        <div className="col-md-3">
                                            <ColumnHeader columnName="Email Address" data-testid="check-in.players.header-email" />
                                        </div>
                                        <div className="col-md-3">
                                            <ColumnHeader columnName="Draw" data-testid="check-in.players.header-draw" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3 p0">
                                    <div className="row">
                                        <div className={`col-md-2`}>
                                            <ColumnHeader columnName="Ct" data-testid="check-in.players.header-court" />
                                        </div>
                                        <div className={`col-md-6`}>
                                            <ColumnHeader columnName="Partner" data-testid="check-in.players.header-partner" />
                                        </div>
                                        <div className="col-md-4" />
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className={`all-players-list ${isLoading && 'opacity05'}`}>
                            {!isLoading && players && !!players.length && players.map(player => {
                                return (
                                    <PlayersForCheckInItem
                                        key={player.memberId}
                                        player={player}
                                        showHighSchoolName={showHighSchoolName}
                                        handleSelectPlayerForCheckIn={handleSelectPlayerForCheckIn}
                                        drawsDict={drawsDict}
                                    />
                                );
                            })}
                            {!isLoading && players.length < 1 && (
                                <div className="text-center mt48">
                                    <p data-testid="check-in.players.empty-msg">No players available for check-in.</p>
                                    <p data-testid="check-in.players.empty-note"><i><u>Note:</u> Only players added to draws will appear in the check-in desk.</i></p>
                                </div>
                            )}
                            {isLoading && (
                                <div className="text-center mt48" data-testid="check-in.players.loading">Loading Players...</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PlayersForCheckIn.propTypes = {
    players: PropTypes.objectOf(any).isRequired,
    handleSortByName: PropTypes.func.isRequired,
    handleSelectPlayerForCheckIn: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    showHighSchoolName: PropTypes.bool,
};

PlayersForCheckIn.defaultProps = {
    isLoading: false,
    showHighSchoolName: false,
};

export default PlayersForCheckIn;
